<template>
  <div class="check-success">
    <div class="head">选择学科</div>
    <div class="content">
      <img class="logo" src="../../assets/image/yes.png" alt="成功" />
      <p class="tips">个人信息修改成功！</p>
      <div class="info">
        <div class="info-item">
          <span class="info-title">姓名</span>
          <span class="info-content">{{ username }}</span>
        </div>
        <div class="info-item" v-show="orgShow">
          <span class="info-title">组织</span>
          <span class="info-content">{{ orgName }}</span>
        </div>
        <div class="info-item">
          <span class="info-title">学科</span>
          <span class="info-content">{{ subjectText }}</span>
        </div>
      </div>
      <div class="i-know" @click="handleClick">知道了({{ num }})</div>
    </div>
  </div>
</template>

<script>
import {getUser} from '@/api'
import {userInfoSubject} from '@/api/dd'
import { ddLogin } from '@/dingtalk/index'
export default {
  name: 'checkSuccess',
  data() {
    return {
      timer: null,
      num: 5,
      username: '',
      orgName: this.$route.query.choice,
      subjectText: '',
      orgShow: false
    }
  },
  methods: {
    handleClick() {
      clearInterval(this.timer)
      // localStorage.removeItem('Authorization')
      this.$router.replace('/home')
    },
    getUserInfo() {
      getUser().then(res => {
        if (res.code === 0) {
          const data = res.data
          this.id = data.id
          this.username = data.name
          this.getSubject()
        }
      })
    },
    getSubject() {
      userInfoSubject(this.id).then(res => {
        const data = res.data.data
        data.forEach(item => {
          this.subjectText += `${item.stageName},${item.subjectName}、`
        })
        this.timer = setInterval(() => {
          this.num -= 1
          if (this.num <= 0) {
            clearInterval(this.timer)
            // localStorage.removeItem('Authorization')
            this.$router.replace('/home')
          }
        }, 1000)
      })
    }
  },
  created() {
    localStorage.removeItem('Authorization')
    ddLogin(this.getUserInfo)
  }
}
</script>

<style lang="scss">
.check-success {
  width: 100%;
  min-height: 100%;
  background-color: #f4f4f4;
  .head {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background-color: #fff;
    font-size: 17px;
    font-weight: 700;
  }
  .content {
    margin-top: 60px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logo {
      width: 53px;
      height: 53px;
    }
    .tips {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }
    .info {
      margin-top: 32px;
      width: 100%;
      padding: 25px 16px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 8px;
      .info-item {
        margin-bottom: 32px;
        &:last-child {
          margin-bottom: 0;
        }
        .info-title {
          font-size: 14px;
          color: #909399;
        }
        .info-content {
          margin-left: 21px;
          font-size: 15px;
          color: #303133;
        }
      }
    }
    .i-know {
      margin-top: 44px;
      width: 90%;
      height: 47px;
      background: linear-gradient(#4465f3 0%, #4a86f6 100%);
      border-radius: 24px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 47px;
    }
  }
}
</style>
